import { useState, useCallback, useEffect } from "react";

export interface ShopSettings {
  shopName: string;
  shopAddress: string;
  phone1: string;
  phone2: string;
  receiptNote: string;
  logo: string;
  theme: "light" | "dark" | "system";
  primaryColor: string;
}

const getApiUrl = () => {
  return import.meta.env.VITE_KV_API_URL || 'https://qandil-realtime-api.qandil.workers.dev';
};

export function useShopSettings(open: boolean) {
  const [shopSettings, setShopSettings] = useState<ShopSettings>({
    shopName: "پێشانگای قەندیل",
    shopAddress: "",
    phone1: "",
    phone2: "",
    receiptNote: "",
    logo: "",
    theme: "system",
    primaryColor: "default",
  });

  const fetchShopSettings = useCallback(async () => {
    try {
      const token = localStorage.getItem('auth-token') || import.meta.env.VITE_KV_TOKEN;
      const response = await fetch(`${getApiUrl()}/settings`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setShopSettings({
          shopName: data.shopName || "پێشانگای قەندیل",
          shopAddress: data.shopAddress || "",
          phone1: data.phone1 || "",
          phone2: data.phone2 || "",
          receiptNote: data.receiptNote || "",
          logo: data.logo || "",
          theme: "system",
          primaryColor: "default",
        });
      }
    } catch (error) {
      console.error('Error fetching shop settings:', error);
    }
  }, []);

  useEffect(() => {
    if (open) {
      fetchShopSettings();
    }
  }, [open, fetchShopSettings]);

  return { shopSettings, fetchShopSettings };
}
